// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"414":"552b8354","493":"fd0608e7","950":"c799da4c"}[chunkId] + ".js";
};